import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {useBrand} from "../../component/BrandProvider";

interface Item {
	SlotNumber: number;
	ItemName: string;
	Amount: number;
	ItemType: string;
}

interface ItemData {
	label: string;
	value: string;
}

const fetchCustomerItems = async (baseUrl: string): Promise<ItemData[]> => {
	const response = await axios.get(`${baseUrl}/api/Customers/Get-Items`);
	const data: Item[] = response.data;

	return data.map((item) => ({
		label: item.ItemName,
		value: item.ItemType.toString(),
	}));
};

export const useGetCustomerItems = () => {
	const {url} = useBrand();

	return useQuery<ItemData[]>({
		queryKey: ["customerItems", url],
		queryFn: () => fetchCustomerItems(url),
		staleTime: 24 * 60 * 60 * 1000,
		refetchOnWindowFocus: false,
		gcTime: 23 * 59 * 60 * 1000
	});
};
